import { render } from "./CheckProduct.vue?vue&type=template&id=372301e8"
import script from "./CheckProduct.vue?vue&type=script&lang=js"
export * from "./CheckProduct.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__